import { Component, Input } from '@angular/core';

@Component({
  selector: 'mk-wave',
  template: `
    <div class="sk-wave">
      <div class="sk-rect sk-rect1" [style.background-color]="color"></div>
      <div class="sk-rect sk-rect2" [style.background-color]="color"></div>
      <div class="sk-rect sk-rect3" [style.background-color]="color"></div>
      <div class="sk-rect sk-rect4" [style.background-color]="color"></div>
      <div class="sk-rect sk-rect5" [style.background-color]="color"></div>
    </div>`,
  styles: [`.sk-wave{margin:40px auto;width:50px;height:40px;text-align:center;font-size:10px}.sk-wave .sk-rect{height:100%;width:6px;display:inline-block;-webkit-animation:1.2s ease-in-out infinite sk-waveStretchDelay;animation:1.2s ease-in-out infinite sk-waveStretchDelay}.sk-wave .sk-rect1{-webkit-animation-delay:-1.2s;animation-delay:-1.2s}.sk-wave .sk-rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-wave .sk-rect3{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-wave .sk-rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-wave .sk-rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes sk-waveStretchDelay{0%,100%,40%{-webkit-transform:scaleY(.4);transform:scaleY(.4)}20%{-webkit-transform:scaleY(1);transform:scaleY(1)}}@keyframes sk-waveStretchDelay{0%,100%,40%{-webkit-transform:scaleY(.4);transform:scaleY(.4)}20%{-webkit-transform:scaleY(1);transform:scaleY(1)}}`]
})
export class WaveComponent {
  @Input() color = '#da4733';
}
